// cspell: disable
//! just a temporary file for faking notification fetch

import type {RawNotification} from "./apiService";

const refTimestamp = Math.floor(Date.now() / 1000);

export const fetchFakeData: RawNotification[] = [
	{
		id: crypto.randomUUID(),
		subject: "TTL expired",
		message: "This notification shouldn't be visible at all.",
		severity: "INFORMATION",
		timestamp: refTimestamp - 10 * 24 * 60 * 60,
		ttl: 1 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: crypto.randomUUID(),
		subject: "Notification from today",
		message: "This notification should be grouped under today.",
		severity: "ERROR",
		timestamp: refTimestamp,
		ttl: 1 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: crypto.randomUUID(),
		subject: "Notification from yesterday",
		message: "This notification should be grouped under yesterday.",
		severity: "WARNING",
		timestamp: refTimestamp - 24 * 60 * 60,
		ttl: 2 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},

	{
		id: crypto.randomUUID(),
		subject: "Notification from older",
		message: "This notification should be grouped under older.",
		severity: "INFORMATION",
		timestamp: refTimestamp - 2 * 24 * 60 * 60,
		ttl: 3 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},

	{
		id: crypto.randomUUID(),
		subject: "Very very old Notification",
		message: "This notification should be grouped under older.",
		severity: "INFORMATION",
		timestamp: refTimestamp - 999 * 24 * 60 * 60,
		ttl: 1000 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},

	{
		id: "12",
		subject: "ttl: 0s",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 0,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "11",
		subject: "ttl: 50s",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 50,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "10",
		subject: "ttl: 2m",
		message: "You can now change your profile picture.",
		severity: "WARNING",
		timestamp: refTimestamp,
		ttl: 2 * 60,

		additionalInformationEMail: null,
		category: "eshop_approval_mandatory",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "9",
		subject: "From yesterday",
		message: "You can now change your profile picture.",
		severity: "ERROR",
		timestamp: refTimestamp - 24 * 60 * 60,
		ttl: 10 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "eshop_approval_optional",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "8",
		subject: "From before yesterday",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp - 3 * 24 * 60 * 60,
		ttl: 10 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "7",
		subject: "ttl: 5m",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 5 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "6",
		subject: "ttl: 59m",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 59 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "5",
		subject: "ttl: 1h",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 1 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "4",
		subject: "ttl: 3h",
		message: "You can now change your profile picture.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 3 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "3",
		subject: "tt: 23h59m",
		message: "Look mum, there's a [link](https://trumpf.com.cms.qa.tru/go/mytrumpf/my-service-cases/case/1337) in my message.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 23 * 60 * 60 + 59,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "2",
		subject: "ttl: 2d",
		message: "I love _italian_ food!",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 2 * 24 * 60 * 60,

		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "1",
		subject: "ttl: 999d",
		message: "That's a **bold** statement.",
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 999 * 24 * 60 * 60,
		additionalInformationEMail: null,
		category: "service",
		customerNumber: "123456",
		equipmentNumber: "789012",
	},
	{
		id: "0",
		subject: "service case example Multiline",
		message: `Case [1337](https://trumpf.com.cms.qa.tru/go/mytrumpf/my-service-cases/case/1337 "fancy title") was closed. We hope you like the service we provided!
		
		Lets get in touch if you have any questions.`,
		severity: "INFORMATION",
		timestamp: refTimestamp,
		ttl: 72 * 60 * 60,
		additionalInformationEMail: null,
		category: "service",
		customerNumber: "DEMO_TWDE",
		equipmentNumber: "TWDEDEMO009",
	},
];
